import React from 'react';
import { useLoggedIn } from 'bv-hooks';
import withLazyLoad from 'bv-lazy-load';
import UserMessages from './user_messages';

const EnhancedOutcomeOffers = withLazyLoad()('enhancedOutcomeOffers');

export default () => {
  const loggedIn = useLoggedIn();

  if (!loggedIn) return null;

  return (
    <>
      <UserMessages />
      <EnhancedOutcomeOffers />
    </>
  );
};
